/*
    Imports the API URL from the config.
*/
import {APP_CONFIG} from "../config"

export default {
    /*
        GET  /v1/projects/{project}/sms/short-codes/{id}
    */
    getShortCode (params) {
        let url = `${APP_CONFIG.URL}projects/${params.project}/sms/short-codes/${params.id}?include=services`;
        return axios.get(url).then(response => {
            return response.data.data;
        });
    },

    getAllProjectShortCodes(params) {
        return axios.get(`projects/${params.project}/sms/short-codes?service=${params.service}`)
            .then(response => {
                return  response.data.data;
            });
    }
}
